import { jwtDecode } from "jwt-decode";
import { recuperarCacheDescriptografado } from "./cacheHandler";

export const isTokenExpirado = () => {
    let token = recuperarCacheDescriptografado("access_token");

    if (!token) return true;

    try {
        const tokenDescriptografado = jwtDecode(token);
        const dataAtual = new Date().getTime() / 1000; 
        return tokenDescriptografado.exp < dataAtual;
    } catch (error) {
        return true; 
    }
}

//TODO: Implementar refresh token